import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import { Avatar, Card, CardContent, CardHeader, Container, Grid, Stack, styled, Typography } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Page from '../components/Page';
import { AccountService } from '../Services/account.service';

export const ViewUser = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [user, setUser] = useState();

  useEffect(() => {
    AccountService.GetAccountById(id, lang).then((res) => {
      setUser(res);
    });
  }, [id, lang]);

  const Image = styled('img')({});

  return (
    <Page title={id}>
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('viewUser.title')}
          </Typography>
          {/* <Button variant="contained" component={RouterLink} to="#" startIcon={<Iconify icon="eva:plus-fill" />}>
          {t('account.create')}
        </Button> */}
        </Stack>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={8}>
            <Card>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4} container justifyContent={'center'}>
                    {user?.avatar.match('https://') ? (
                      <Image
                        sx={{
                          borderRadius: '10px',
                        }}
                        width={'128px'}
                        height={'128px'}
                        src={user?.avatar}
                      />
                    ) : (
                      <Image
                        sx={{
                          borderRadius: '10px',
                        }}
                        width={'128px'}
                        height={'128px'}
                        src={`${process.env.REACT_APP_IMAGE}${user?.avatar}`}
                      />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography mb={1} variant="h6">
                      {user?.fullname}
                    </Typography>
                    <Stack direction={'row'} spacing={1}>
                      <Typography variant="body1">{t('viewUser.username')} </Typography>
                      <Typography variant="subtitle1">{user?.username}</Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={1}>
                      <Typography variant="body1">{t('viewUser.phone')} </Typography>
                      <Typography variant="subtitle1">{user?.phone}</Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={1}>
                      <Typography variant="body1">{t('viewUser.role')} </Typography>
                      <Typography variant="subtitle1">{user?.role}</Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={1}>
                      <Typography variant="body1">{t('viewUser.status')} </Typography>
                      <Typography variant="subtitle1">{user?.status}</Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={1}>
                      <Typography variant="body1">{t('viewUser.create')} </Typography>
                      <Typography variant="subtitle1">{moment(user?.createdAt).format('DD/MM/YYYY-HH:mm')}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card>
              <CardHeader title="Logs" />
              <CardContent
                sx={{
                  '& .MuiTimelineItem-missingOppositeContent:before': {
                    display: 'none',
                  },
                }}
              >
                <Timeline>
                  {user?.logs.map((item, index) => (
                    <OrderItem
                      key={item._id}
                      item={{
                        time: item.time,
                        title: item[lang],
                        type: item.typeLog,
                        username: item.user.username,
                      }}
                      isLast={index === user.logs.length - 1}
                    />
                  ))}
                </Timeline>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

// ----------------------------------------------------------------------

OrderItem.propTypes = {
  isLast: PropTypes.bool,
  item: PropTypes.shape({
    time: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    username: PropTypes.string,
  }),
};

function OrderItem({ item, isLast }) {
  const { type, title, time } = item;
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot
          color={
            (type === 'enable' && 'primary') ||
            (type === 'create' && 'success') ||
            (type === 'reset' && 'info') ||
            (type === 'edit' && 'warning') ||
            (type === 'disable' && 'grey') ||
            'error'
          }
        />
        {isLast ? null : <TimelineConnector />}
      </TimelineSeparator>

      <TimelineContent>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          @{item.username}
        </Typography>

        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {moment(time).format('DD/MM/YYYY-HH:mm')}
        </Typography>
      </TimelineContent>
    </TimelineItem>
  );
}
